import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Link from '@material-ui/core/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { SHOW_LOGO_2DO_ESCALON_URL, PRUDENCE_MICRO_BRAND, PRUDENCE_MICRO_HOSTS } from '../data';

const programHighlights = [
  'Cultura pop, juventud y estilo de vida con humor inteligente.',
  'Relaciones modernas, mitos del placer, bienestar íntimo y lanzamientos innovadores.',
  'Entrevistas, segmentos patrocinados e inserts en vivo — tono fresco, cercano y sin tabúes.',
];

const metrics = [
  {
    value: '30 s',
    label: `Micros «${PRUDENCE_MICRO_BRAND}»`,
    subtitle: `Humor inteligente y educación sexual con ${PRUDENCE_MICRO_HOSTS} en rotativa Radio Visual y 2do Escalón.`,
    featured: true,
  },
  { value: '8/mes', label: 'Artículos TNO Digest', subtitle: '2 por semana · SEO' },
  { value: '+90K', label: 'Seguidores TNO Network', subtitle: 'Ecosistema social' },
];

const Alcance = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4} textAlign="center">
        <Typography
          sx={{ textTransform: 'uppercase', fontWeight: 600, letterSpacing: 1 }}
          gutterBottom
          color="primary"
        >
          2. Estrategia selectiva
        </Typography>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Integración en 2do Escalón
        </Typography>
        <Typography variant="body1" color="textSecondary" sx={{ maxWidth: 560, mx: 'auto' }}>
          Un solo programa en antena concentra la presencia de Prudence en TNO Network.
        </Typography>
      </Box>

      <Box
        component={Card}
        variant="outlined"
        sx={{
          mb: 5,
          borderLeft: 4,
          borderColor: theme.palette.primary.main,
          overflow: 'hidden',
        }}
      >
        <CardContent sx={{ p: { xs: 2, md: 3 } }}>
          <Grid container spacing={3} alignItems="stretch">
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  py: { xs: 2, md: 0 },
                  px: 2,
                  borderRadius: 2,
                  bgcolor: theme.palette.alternate.main,
                }}
              >
                <Box
                  component="img"
                  src={SHOW_LOGO_2DO_ESCALON_URL}
                  alt="2do Escalón"
                  sx={{
                    maxWidth: 220,
                    width: '100%',
                    height: 'auto',
                  }}
                />
              </Box>
            </Grid>

            <Grid item xs={12} md={8}>
              <Typography variant="h5" fontWeight={700} color="primary" gutterBottom>
                2do Escalón
              </Typography>
              <List dense disablePadding sx={{ mb: 2 }}>
                {programHighlights.map((line, index) => (
                  <ListItem key={index} disableGutters alignItems="flex-start" sx={{ py: 0.5 }}>
                    <ListItemIcon sx={{ minWidth: 32, mt: 0.25 }}>
                      <CheckCircleIcon color="primary" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText
                      primary={line}
                      primaryTypographyProps={{ variant: 'body2', color: 'textSecondary' }}
                    />
                  </ListItem>
                ))}
              </List>

              <Link
                href="https://tnonetwork.com/show/2doescalon"
                target="_blank"
                rel="noopener noreferrer"
                color="primary"
                underline="hover"
                variant="body2"
                fontWeight={600}
              >
                Ver programa → tnonetwork.com/show/2doescalon
              </Link>
            </Grid>
          </Grid>
        </CardContent>
      </Box>

      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        gutterBottom
        color="primary"
        align="center"
      >
        Alcance
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        sx={{ maxWidth: 640, mx: 'auto', mb: 3 }}
      >
        Rotativa, editorial y redes — con los micros de la campaña al frente de la señal.
      </Typography>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        {metrics.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              component={Card}
              variant="outlined"
              sx={{
                borderLeft: 4,
                borderColor: theme.palette.primary.main,
                height: '100%',
                ...(item.featured && {
                  borderTop: 4,
                  borderLeft: 4,
                  bgcolor: `${theme.palette.primary.main}0a`,
                }),
              }}
            >
              <CardContent>
                <Typography variant="h4" fontWeight={900} color="primary" gutterBottom>
                  {item.value}
                </Typography>
                <Typography variant="h6" fontWeight={600} gutterBottom>
                  {item.label}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.subtitle}
                </Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Alcance;
